import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import NodeEdgeMapperListTable from '../../../../../components/common/NodeEdgeMapperListTable';
export const EntityStateContextSubCard = ({ apexNode, context }) => {
    const excludeObjectTypeIds = [apexNode.type];
    if (apexNode.type === 'Customer') {
        excludeObjectTypeIds.push('User'); // don't show the direct link to user
    }
    return (_jsx(Stack, { children: _jsx(NodeEdgeMapperListTable, { mapper: context, excludeObjectTypeIds: excludeObjectTypeIds }) }));
};
